import React, { useEffect, useState } from "react";
import { customerApi } from "@/lib/customerApi";
import StoreTopbar from "./StoreTopbar";
import HubFooter from "./HubFooter";
import AccountOverview from "./account/AccountOverview";
import { RiskNotice } from "./RiskNotice";

const PERIODS = [["today", "Today"], ["week", "This week"], ["month", "This month"], ["all", "All time"]];

export default function TrackRecord() {
  const [period, setPeriod] = useState("all");
  const [d, setD] = useState(null);
  useEffect(() => { customerApi.get("/store/track-record", { params: { period } }).then((r) => setD(r.data)).catch(() => setD({})); }, [period]);
  const st = d?.stats;
  return (
    <div data-testid="track-record-page" className="min-h-screen bg-[#050914] text-[#F1F5F9]">
      <StoreTopbar subtitle="Track record" />
      <main className="max-w-6xl mx-auto px-6 py-12">
        <div className="mono text-[11px] uppercase tracking-[0.3em] text-[#34D399]">Founder's demo account · simulated funds · not real money</div>
        <h1 className="text-4xl sm:text-5xl font-medium tracking-tight mt-2">Demo track record</h1>
        <p className="text-[#94A3B8] mt-3 max-w-2xl">
          These results come from the founder's MetaTrader 5 <b className="text-[#F1F5F9]">demo account, which trades with simulated funds</b>, running
          the same released versions of the store bots. They are shown for transparency - good periods and bad - and are not real-money results,
          not a forecast and not an indication of what you may achieve. We don't currently publish verified live-money results.
        </p>
        <section className="mt-8 grid grid-cols-1 gap-6">
          <div className="lg:col-span-2 rounded-xl border border-blue-900/40 bg-[#020617]/70 p-5" data-testid="track-record-stats">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div className="text-lg font-medium">Demo account results (simulated funds)</div>
              <div className="flex gap-1 rounded-xl border border-blue-900/50 bg-[#050914] p-1">
                {PERIODS.map(([id, l]) => (
                  <button key={id} onClick={() => setPeriod(id)} data-testid={`track-period-${id}`}
                    className={`mono text-[10px] uppercase tracking-widest px-3 py-1.5 rounded-lg ${period === id ? "bg-[#38BDF8] text-[#050914]" : "text-[#94A3B8]"}`}>{l}</button>
                ))}
              </div>
            </div>
            {!d ? <div className="mono text-xs text-[#64748B] mt-6">Loading…</div> : !st || !st.account ? (
              <div data-testid="track-record-empty" className="mt-6 text-sm text-[#94A3B8]">Results will appear here as soon as the demo account starts reporting.</div>
            ) : <AccountOverview data={st} onAccount={() => {}} hideAccount />}
          </div>
        </section>
        <p className="text-xs text-[#64748B] mt-8 max-w-3xl leading-relaxed" data-testid="track-record-limitations">
          Limitations: demo accounts use simulated funds, and results can differ materially from a live account because of spreads, slippage,
          requotes, execution speed, liquidity, swap and commission costs. Figures are reported by the software from the demo account's MT5 history
          and may be delayed or incomplete. Past performance is not a reliable indicator of future results.
        </p>
        <RiskNotice testid="track-record-risk" className="mt-6 max-w-3xl" />
      </main>
      <HubFooter />
    </div>
  );
}
